























import { PropType } from 'vue';
import { EventRefined } from '@fullcalendar/core/internal';
import { eventResponseStatus } from '../../../shared/enums/eventResponseStatus';
import { calendarUtil } from '../../../shared/utils/calendarUtil';
import { mapGetters } from 'vuex';
import { types } from '../../store/types/types.js';
import { notificationTypes } from '../../../shared/enums/notificationTypes';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AvatarGroup from '../../../shared/components/AvatarGroup.vue';
import {eventTypeEnum} from "../../../shared/enums/eventTypeEnum";
import LessonExtendedInfo from "./LessonExtendedInfo.vue";

export default {
  components: {LessonExtendedInfo, AvatarGroup, Icon },
  props: {
    eventModel: { type: Object as PropType<EventRefined>, required: true },
  },
  computed: {
    ...mapGetters({
      notifications: types.GET_NOTIFICATIONS,
    }),
    resourceProfiles() {
      const resources = this.eventModel.getResources().filter(resource => resource != null) || [];
      return resources.map(resource => ({ ...resource.extendedProps, id: resource.extendedProps.singleId }));
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    status(): eventResponseStatus {
      return this.eventModel.extendedProps.responseStatus;
    },
    isPrivate() {
      return this.eventModel.extendedProps.private;
    },
    hasNote() {
      return Boolean(this.eventModel.extendedProps.lesson?.hasRelevantNote);
    },
    indicator() {
      if (this.eventModel.extendedProps.private) {
        return 'none';
      }
      switch (this.status) {
        case eventResponseStatus.ACCEPTED:
          return 'accepted';
        case eventResponseStatus.TENTATIVE:
          return 'tentative';
        case eventResponseStatus.WAITING:
          return 'waiting';
        default:
          return 'none';
      }
    },
    location() {
      return calendarUtil.getPrimaryLocation(this.eventModel.extendedProps);
    },
    hasNotification() {
      return this.notifications.some(
        notification =>
          this.eventModel.extendedProps.eventId &&
          notification.eventId == this.eventModel.extendedProps.eventId &&
          notification.notificationType === notificationTypes.BADGE
      );
    },
    title() {
      return this.eventModel.title;
    },
    metadata() {
      if (!this.eventModel.extendedProps.metadata) {
        return '';
      }
      return `(${this.eventModel.extendedProps.metadata})`;
    },
    isLesson(): boolean {
      return this.eventModel.extendedProps?.type === eventTypeEnum.LESSON && this.eventModel.extendedProps?.lesson;
    },
    lesson() {
      return this.eventModel.extendedProps?.lesson;
    },
    invitedGroups() {
      return this.eventModel.extendedProps?.invitedGroups;
    },
  },
};
